module.exports = __webpack_public_path__ + "static/media/casting_tariqh.6da900b5.jpg";